var api = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../node_modules/css-loader/dist/cjs.js??ref--10-1!../../../node_modules/postcss-loader/dist/cjs.js??ref--10-2!../../../node_modules/sass-loader/dist/cjs.js??ref--10-3!./parsley.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"attributes":{"nonce":"dGhpcyBpcyB3aGF0IEkgd2FudCB0byB1c2UgZm9yIHRoZSBlbXMgbm9uY2U="}};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};